const Payment = () => {
    return (
      <div className="flex justify-center  mt-20 mb-40">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-4 text-center">Order Received</h1>
          <p className="text-lg mb-4"> Your order has been received successfully.</p>
          <p c lassName="text-lg mt-4">We appreciate your business and hope to continue serving you in the future.</p>
        </div>
      </div>
    );
  };
  
  export default Payment;
  